import React from 'react'
import { Alert, Button, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material'

const resellerValues = row => ({
  code: row.LR_user_code || '',
  name: [row.first_name, row.last_name].filter(Boolean).join(' '),
  username: row.username || '',
  company: row.company_name || row.view_text || '',
  email: row.email || '',
  country: row.company_country || '',
})

export default function ResellerSearchList({ rows, selectedId, onSelect, allowAny = false, disabled = false }) {
  const [search, setSearch] = React.useState('')
  const query = search.trim().toLocaleLowerCase()
  const filteredRows = rows.filter(row =>
    Object.values(resellerValues(row)).some(value => String(value).toLocaleLowerCase().includes(query))
  )

  return (
    <Stack spacing={2} sx={{ mt: 1 }}>
      <TextField
        size="small"
        fullWidth
        autoFocus
        label="Search resellers (company, name, country, email, username, LR user code)"
        value={search}
        onChange={event => setSearch(event.target.value)}
        disabled={disabled}
      />
      {allowAny && <Button
        onClick={() => onSelect(-1)}
        disabled={disabled}
        variant={selectedId === -1 ? 'contained' : 'outlined'}
        sx={{ alignSelf: 'flex-start' }}
      >ANY (country required)</Button>}
      <Typography variant="body2" color="text.secondary">{filteredRows.length} resellers</Typography>
      {filteredRows.length === 0 ? <Alert severity="info">No resellers found</Alert> : (
        <TableContainer sx={{ maxHeight: 'calc(100vh - 300px)' }}>
          <Table stickyHeader size="small" aria-label="Reseller search results">
            <TableHead>
              <TableRow>
                <TableCell>LR user code</TableCell>
                <TableCell>Name / Username</TableCell>
                <TableCell>Company / Email</TableCell>
                <TableCell>Country</TableCell>
                <TableCell align="right">Selection</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredRows.map(row => {
                const values = resellerValues(row)
                return (
                  <TableRow key={row.id} selected={row.id === selectedId} hover>
                    <TableCell>{values.code}</TableCell>
                    <TableCell>
                      {values.name}
                      <Typography variant="body2" color="primary">{values.username}</Typography>
                    </TableCell>
                    <TableCell>
                      {values.company}
                      <Typography variant="body2" color="text.secondary">{values.email}</Typography>
                    </TableCell>
                    <TableCell>{values.country}</TableCell>
                    <TableCell align="right">
                      <Button size="small" disabled={disabled} onClick={() => onSelect(row.id)}
                        aria-label={`Select ${values.company || values.username || row.id}`}>
                        {row.id === selectedId ? 'SELECTED' : 'SELECT'}
                      </Button>
                    </TableCell>
                  </TableRow>
                )
              })}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Stack>
  )
}
